import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export function ImpersonationBanner() {
  const { isImpersonating, impersonatingAs, switchBack } = useAuth();

  if (!isImpersonating) return null;

  return (
    <div className="bg-accent-gold/20 border-b border-accent-gold/40 px-4 py-2 flex items-center justify-center gap-3 text-sm">
      <AlertTriangle className="h-4 w-4 text-accent-gold shrink-0" />
      <span className="text-foreground font-medium">
        You are viewing as <strong>{impersonatingAs || 'another user'}</strong>
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 text-xs border-accent-gold/50 hover:bg-accent-gold/20"
        onClick={switchBack}
      >
        Switch Back
      </Button>
    </div>
  );
}
